// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chipHeight[data-v-7bd57d98] {\n  height: auto;\n  min-height: 22px;\n}\n.circleWidth[data-v-7bd57d98] {\n  width: 22px;\n}\n.maxChipWidth[data-v-7bd57d98] {\n  max-width: 17rem;\n}\n.initialColor[data-v-7bd57d98] {\n  color: white !important;\n}\n.chipCustomText[data-v-7bd57d98]{\n  font-size: 16px !important;\n  font-weight: 400;\n  padding: 4px 16px !important;\n  line-height: 19.2px !important;\n}\n", ""]);
// Exports
module.exports = exports;
